module.exports = __webpack_public_path__ + "img/day-pass--icon--gray.33d0b977.svg";